import { render } from "./Suppliers.vue?vue&type=template&id=a2e6db56"
import script from "./Suppliers.vue?vue&type=script&lang=js"
export * from "./Suppliers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Suppliers/Suppliers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a2e6db56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2e6db56', __exports__)) {
    api.reload('a2e6db56', __exports__)
  }
  
  module.hot.accept("./Suppliers.vue?vue&type=template&id=a2e6db56", () => {
    api.rerender('a2e6db56', render)
  })

}


export default __exports__